import { CalculatedPrice } from '@teko/cart/v2';
import { logger } from '@teko/log';
import { useProductDetailState, useServices } from 'contexts';
import useSWR from 'swr';

export const useGetPriceDetailPage = () => {
  const { cartServiceV2 } = useServices();
  const { payloadAddToCart } = useProductDetailState();

  const { data: calculatePrice } = useSWR<CalculatedPrice | undefined>(
    ['/calculatePrice', payloadAddToCart?.sku],
    async () => {
      try {
        if (!payloadAddToCart?.sku) return undefined;

        return await cartServiceV2.calculatePrice({
          sku: payloadAddToCart.sku,
          quantity: 1,
        });
      } catch (e) {
        logger.error(`Error occur when fetching calculatePrice: ${e}`);
        return undefined;
      }
    },
    {
      revalidateOnFocus: false,
    },
  );

  return { calculatePrice };
};
